import RegisterForm from "../components/RegisterForm";

function Register() {
    return (
        <div>
            <RegisterForm />
        </div>
    );
}

export default Register;